import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import ProjectsSectionML from '../components/sections/ProjectsSectionML';

const ProjectsPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero — extends behind the transparent fixed header on this route */}
      <section className="bg-[#023E8A] text-white pt-44 pb-24">
        <div className="container mx-auto px-6">
          <div className="max-w-3xl">
            <div className="flex items-center gap-3 mb-6">
              <div className="h-px w-10 bg-[#48CAE4]" />
              <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#48CAE4]">Portfolio</p>
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-[1.1] tracking-tight mb-6">
              Projects & Case Studies
            </h1>
            <p className="text-lg text-white/80 font-light leading-relaxed max-w-2xl">
              17+ years of delivering enterprise solutions across automotive, trading, infrastructure and business architecture.
            </p>
          </div>
        </div>
      </section>

      <ProjectsSectionML />

      {/* CTA */}
      <section className="bg-[#023E8A] py-16">
        <div className="container mx-auto px-6 text-center">
          <h3 className="text-2xl md:text-3xl font-extrabold text-white mb-4">Have a Project in Mind?</h3>
          <p className="text-white/70 mb-8 max-w-lg mx-auto">We would love to hear about your next challenge.</p>
          <Link to="/contact">
            <button className="bg-[#FF6B35] hover:bg-[#E5562D] text-white font-bold px-10 py-4 rounded-xl text-lg transition-all hover:scale-105 inline-flex items-center gap-2">
              Start a Conversation <ArrowRight className="w-5 h-5" />
            </button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default ProjectsPage;
